import React from "react";
import { ExportButton } from "@/components/ExportButton";
import {
  BooleanField,
  CreateButton,
  Datagrid,
  FunctionField,
  List,
  NumberField,
  Pagination,
  TextField,
  TextInput,
  TopToolbar,
  type ListProps,
  type RaRecord,
} from "react-admin";
import Chip from "@mui/material/Chip";
import { formatINR } from "@/utils";

const filters = [
  <TextInput key="q" source="q" label="Search code or name" alwaysOn sx={{ minWidth: 260 }} />,
];

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export default function FmbContributionCategoryList(props: ListProps) {
  return (
    <List
      {...props}
      title="Contribution Categories"
      perPage={50}
      sort={{ field: "sortOrder", order: "ASC" }}
      filters={filters}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
      actions={<ListActions />}
    >
      <Datagrid bulkActionButtons={false} rowClick="edit">
        <TextField source="code" />
        <TextField source="name" />
        <FunctionField
          label="Default unit amount"
          sortBy="defaultUnitAmount"
          render={(record: RaRecord) =>
            record?.defaultUnitAmount != null ? formatINR(record.defaultUnitAmount as number) : "—"
          }
        />
        <NumberField source="sortOrder" />
        <FunctionField
          label="System"
          render={(record: RaRecord) =>
            record?.isSystem ? (
              <Chip label="System" size="small" color="primary" variant="outlined" />
            ) : (
              "—"
            )
          }
        />
        <BooleanField source="isActive" label="Active" />
      </Datagrid>
    </List>
  );
}
